import { z } from 'zod'

/**
 * Cloche des listes Clients et Contrats (`client_sms_alert_status_v1`) : vrai si le client reçoit les alertes de
 * déneigement par SMS (un numéro avec consentement accordé, non désabonné). Règle calculée par le serveur.
 */
export const clientSmsAlertStatusSchema = z.array(z.object({ clientId: z.string(), active: z.boolean() }))
export type ClientSmsAlertStatus = z.infer<typeof clientSmsAlertStatusSchema>
